export const sortDataArrayByNumber = (
  data: any[],
  columnIndex: number,
  direction: 'asc' | 'desc',
) => {
  const dataCopy = [...data];
  return dataCopy.sort((a, b) =>
    direction === 'asc'
      ? (a.cellData[columnIndex] as number) -
        (b.cellData[columnIndex] as number)
      : (b.cellData[columnIndex] as number) -
        (a.cellData[columnIndex] as number),
  );
};

export const sortDataArrayByDayRange = (
  data: any[],
  direction: 'asc' | 'desc',
) => {
  const dataCopy = [...data];
  return dataCopy.sort((a, b) => {
    const aFirstNumber = parseInt((a.cellData[0] as string).split('-')[0], 10);
    const bFirstNumber = parseInt((b.cellData[0] as string).split('-')[0], 10);
    return direction === 'asc'
      ? aFirstNumber - bFirstNumber
      : bFirstNumber - aFirstNumber;
  });
};

const convertToNullIfSpaces = (value: string | number | null) => {
  if (typeof value === 'number') {
    return value;
  }
  return value != null && value.trim() === '' ? null : value;
};

export const sortDataArrayByString = (
  data: { cellData: (string | number | undefined | null)[]; row: string }[],
  columnIndex: number,
  direction: 'asc' | 'desc',
) => {
  const dataCopy = [...data];
  return dataCopy.sort((a, b) => {
    const cellDataA = convertToNullIfSpaces(a.cellData[columnIndex] || '');
    const cellDataB = convertToNullIfSpaces(b.cellData[columnIndex] || '');

    if (cellDataA === null || cellDataB === null) {
      if (cellDataA === null && cellDataB === null) {
        return 0;
      } else if (cellDataA === null) {
        return direction === 'desc' ? -1 : 1;
      } else {
        return direction === 'desc' ? 1 : -1;
      }
    }

    return direction === 'asc'
      ? String(cellDataA).localeCompare(String(cellDataB))
      : String(cellDataB).localeCompare(String(cellDataA));
  });
};

export const sortDataArrayByDate = (
  data: { cellData: (string | undefined | null)[] }[],
  columnIndex: number,
  direction: 'asc' | 'desc',
) =>
  data.sort((a, b) => {
    const dateA = a.cellData[columnIndex] as string;
    const dateB = b.cellData[columnIndex] as string;

    if (dateA === null || dateA === undefined || dateA.trim() === '') {
      return direction === 'asc' ? -1 : 1;
    }

    if (dateB === null || dateB === undefined || dateB.trim() === '') {
      return direction === 'asc' ? 1 : -1;
    }

    const [dayA, monthA, yearA] = dateA.split('/').map(Number);
    const [dayB, monthB, yearB] = dateB.split('/').map(Number);

    if (isNaN(dayA) || isNaN(monthA) || isNaN(yearA)) {
      return direction === 'asc' ? -1 : 1;
    }

    if (isNaN(dayB) || isNaN(monthB) || isNaN(yearB)) {
      return direction === 'asc' ? 1 : -1;
    }

    const dateObjectA = new Date(yearA, monthA - 1, dayA);
    const dateObjectB = new Date(yearB, monthB - 1, dayB);

    if (isNaN(dateObjectA.getTime())) {
      return direction === 'asc' ? -1 : 1;
    }

    if (isNaN(dateObjectB.getTime())) {
      return direction === 'asc' ? 1 : -1;
    }

    if (direction === 'asc') {
      return dateObjectA.getTime() - dateObjectB.getTime();
    } else {
      return dateObjectB.getTime() - dateObjectA.getTime();
    }
  });

export const sortDataArrayByPercentage = (
  data: any[],
  columnIndex: number,
  direction: 'asc' | 'desc',
) => {
  const dataCopy = [...data];
  return dataCopy.sort((a, b) => {
    const percentageA = parseFloat(a.cellData[columnIndex]);
    const percentageB = parseFloat(b.cellData[columnIndex]);
    return direction === 'asc'
      ? percentageA - percentageB
      : percentageB - percentageA;
  });
};

export const sortByDefaultOrder = (data: any[], direction: 'asc' | 'desc') => {
  const dataCopy = [...data];
  return direction === 'desc' ? dataCopy : dataCopy.reverse();
};
